import MainTitle from "components/Common/MainTitle";
import React from "react";
import ON_GC_IMG from "../../assets/images/ONGC.png";

function SectionOngoingProject() {
  const operationalSnapshot = [
    {
      label: "Active rigs under O&M",
      value: "42+",
      detail:
        "Drilling, workover, and jack-up units across ONGC, Oil India, and allied assets.",
    },
    {
      label: "Exploration & production",
      value: "1",
      detail: "South Patan field operations, Gujarat, India.",
    },
    {
      label: "HSE performance culture",
      value: "Zero LTI",
      detail:
        "Proven Lost Time Injury track record in high-risk drilling and production environments.",
    },
    {
      label: "ONGC recognition",
      value: "Awarded",
      detail:
        "Best Performing Rig (2022 — Rig Sagar Shakti) & Best Performing Drilling Rig (2023 — Rig CW-IX), ONGC Chairman awards; Best Drilling award at ONGC Drilling Rig M4900, Saksham 2025–26.",
    },
  ];

  const omServices = [
    "Well design, drilling, and workover execution with experienced rig crews.",
    "Rig operations, preventive maintenance, and reliability programs aligned to operator standards.",
    "Production support, wellsite supervision, and HSE systems consistent with field realities.",
    "Rapid staffing models for campaign work, shutdowns, and campaign-based drilling.",
  ];

  const ongoingOperations = [
    {
      title: "ONGC — Mumbai Offshore",
      items: [
        "O&M of 1 jack-up drilling rig with experienced manpower (Rig Sagar Shakti).",
      ],
    },
    {
      title: "ONGC — Cambay & Ahmedabad assets, Gujarat",
      items: [
        "O&M of onshore drilling land rig, Cambay asset.",
        "O&M of 8 workover rigs, Ankleshwar asset.",
        "O&M of 3 workover rigs, Ahmedabad asset.",
      ],
    },
    {
      title: "ONGC — Karaikal asset, Puducherry",
      items: ["O&M of 2 workover rigs."],
    },
    {
      title: "Oil India — Duliajan, Assam",
      items: ["O&M of 3 workover rigs."],
    },
    {
      title: "SAC E&P",
      items: [
        "Exploration and production — South Patan field, Gujarat, India.",
      ],
    },
  ];

  return (
    <>
      <div className="container pt-4 pb-2">
        <MainTitle
          text="Operational Footprint & Ongoing Projects"
          className={"text-center"}
          position={"center"}
          width={"280px"}
        />
        <p className="SectionAboutText text-center mt-3 mb-4">
          Figures reflect our active India operations and are updated to align
          with the SAC Manpower positioning deck (field operations + workforce
          mobilization).
        </p>

        <div className="row mb-4">
          {operationalSnapshot.map((card) => (
            <div className="col-md-6 col-lg-3 mb-3" key={card.label}>
              <div className="card h-100 border-0 shadow-sm recruitment-snapshot-card">
                <div className="card-body">
                  <p className="recruitment-snapshot-value mb-1">{card.value}</p>
                  <h3 className="ServiceCardTitle mb-2">{card.label}</h3>
                  <p className="SectionAboutText mb-0">{card.detail}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="row mb-4">
          <div className="col-lg-6 mb-3 mb-lg-0">
            <h3 className="ServiceCardTitle mb-3">O&amp;M services scope</h3>
            <ul className="SectionAboutText pl-3">
              {omServices.map((line) => (
                <li key={line} className="mb-2">
                  {line}
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 d-flex align-items-center justify-content-center">
            <img src={ON_GC_IMG} alt="ONGC" className="img-fluid" style={{ maxHeight: "140px" }} />
          </div>
        </div>

        <h3 className="ServiceCardTitle mb-3">Ongoing operations by asset</h3>
        <div className="row">
          <div className="col-12">
            {ongoingOperations.map((block) => (
              <div key={block.title} className="mb-4">
                <h4 className="ServiceCardTitle mb-2" style={{ fontSize: "17px" }}>
                  {block.title}
                </h4>
                <ul className="pl-3 mb-0">
                  {block.items.map((data) => (
                    <li className="projectList mb-2" key={data}>
                      {data}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionOngoingProject;
